var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.shortText)+" "),_c('app-info',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChangeInfoShown),expression:"isChangeInfoShown"}],attrs:{"text":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }